import { TApplicationState } from '../../types/redux';
import { getUrlPath } from '../path';

export const promosSeoPageUrlSelector = (state: TApplicationState): string => {
  const fullPath = getUrlPath(state);

  return `${fullPath}akcii-i-skidki/`;
};
